// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-element-button {
  height: 60px;
  border-radius: 8px;
  font-weight: 400;
  cursor: pointer;
  margin: 10px 0px;
  transition-property: color, background;
  transition-duration: 0.1s !important;
  position: relative;
  font-weight: 500;
  display: block;
  outline: none;
  border: none;
}

.form-element-button div {
  line-height: 60px;
  text-align: center;
}

.form-element-button-width-full {
  width: 100%;
}

.form-element-button.secondary {
  background-color: var(--primary-bg-color);
}

.form-element-button-icon {
  width: 54px;
  position: absolute;
  font-size: 24px;
}

.form-element-button-icon.left {
  left: 0px;
  top: 0px;
}

.form-element-button-icon.right {
  right: 0px;
  top: 0px;
}

.form-element-button-lined {
  border: 2px solid var(--primary-color-a) !important;
  background-color: white !important;
  color: var(--primary-color-a) !important;
}

/* blue color */

.form-element-button-theme-blue {
  background-color: var(--primary-color-a);
  color: #fff;
}

.form-element-button-theme-blue:hover {
  background-color: var(--primary-color-a-6);
}

.form-element-button-theme-blue:active {
  background-color: var(--primary-color-a-7);
}

/* black color */

.form-element-button-theme-black {
  background-color: var(--primary-color-b-5);
  color: #fff;
}

.form-element-button-theme-black:hover {
  background-color: var(--primary-color-b-7);
}

.form-element-button-theme-black:active {
  background-color: var(--primary-color-b-8);
}

/* blue secondary color */

.form-element-button-theme-blue-secondary {
  box-shadow: inset 0px 0px 0px 2px var(--primary-color-a);
  color: var(--primary-color-a);
}

.form-element-button-theme-blue-secondary:hover {
  box-shadow: inset 0px 0px 0px 3px var(--primary-color-a-6);
  color: var(--primary-color-a);
}

.form-element-button-theme-blue-secondary:active {
  box-shadow: inset 0px 0px 0px 2px var(--primary-color-a-7);
  color: var(--primary-color-a-7);
}

/* black secondary color */

.form-element-button-theme-black-secondary {
  box-shadow: inset 0px 0px 0px 2px var(--primary-color-b);
  color: var(--primary-color-b);
}

.form-element-button-theme-black-secondary:hover {
  box-shadow: inset 0px 0px 0px 3px var(--primary-color-b);
  color: var(--primary-color-b);
}

.form-element-button-theme-black-secondary:active {
  box-shadow: inset 0px 0px 0px 2px var(--primary-color-b);
  color: var(--primary-color-b);
}

/* disabled */

.form-element-button:disabled {
  cursor: default;
}

.form-element-button.primary:disabled {
  background-color: var(--neutral-color-a-1);
  color: var(--neutral-color-a-2);
}

.form-element-button.secondary:disabled {
  background-color: var(--primary-bg-color);
  color: var(--neutral-color-a-1);
  box-shadow: inset 0px 0px 0px 2px var(--neutral-color-a-1);
}

@media (max-width: 550px) {
  .form-element-button {
    height: 48px;
  }

  .form-element-button div {
    line-height: 48px;
  }
}


.form-element-button:disabled,
.form-element-button:disabled:hover {
  cursor: not-allowed;
  pointer-events: none;
  background-color: var(--neutral-color-a-1);
}

.pricing-card:hover .form-element-button:disabled {
  background-color: var(--neutral-color-a-1) !important;
}

.pricing-card:has(.form-element-button:disabled):hover {
  background-color: inherit !important;
}

.pricing-card:has(.form-element-button:disabled) .pricing-card-name,
.pricing-card:has(.form-element-button:disabled) .pricing-card-price-amount,
.pricing-card:has(.form-element-button:disabled) .pricing-card-price-per {
  color: inherit !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/form/button/FormButton.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA,eAAe;;AAEf;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gBAAgB;;AAEhB;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;;AAEzB;EACE,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,0DAA0D;EAC1D,6BAA6B;AAC/B;;AAEA;EACE,0DAA0D;EAC1D,+BAA+B;AACjC;;AAEA,0BAA0B;;AAE1B;EACE,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA,aAAa;;AAEb;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,0DAA0D;AAC5D;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,yBAAyB;AAC3B","sourcesContent":[".form-element-button {\n  height: 60px;\n  border-radius: 8px;\n  font-weight: 400;\n  cursor: pointer;\n  margin: 10px 0px;\n  transition-property: color, background;\n  transition-duration: 0.1s !important;\n  position: relative;\n  font-weight: 500;\n  display: block;\n  outline: none;\n  border: none;\n}\n\n.form-element-button div {\n  line-height: 60px;\n  text-align: center;\n}\n\n.form-element-button-width-full {\n  width: 100%;\n}\n\n.form-element-button.secondary {\n  background-color: var(--primary-bg-color);\n}\n\n.form-element-button-icon {\n  width: 54px;\n  position: absolute;\n  font-size: 24px;\n}\n\n.form-element-button-icon.left {\n  left: 0px;\n  top: 0px;\n}\n\n.form-element-button-icon.right {\n  right: 0px;\n  top: 0px;\n}\n\n.form-element-button-lined {\n  border: 2px solid var(--primary-color-a) !important;\n  background-color: white !important;\n  color: var(--primary-color-a) !important;\n}\n\n/* blue color */\n\n.form-element-button-theme-blue {\n  background-color: var(--primary-color-a);\n  color: #fff;\n}\n\n.form-element-button-theme-blue:hover {\n  background-color: var(--primary-color-a-6);\n}\n\n.form-element-button-theme-blue:active {\n  background-color: var(--primary-color-a-7);\n}\n\n/* black color */\n\n.form-element-button-theme-black {\n  background-color: var(--primary-color-b-5);\n  color: #fff;\n}\n\n.form-element-button-theme-black:hover {\n  background-color: var(--primary-color-b-7);\n}\n\n.form-element-button-theme-black:active {\n  background-color: var(--primary-color-b-8);\n}\n\n/* blue secondary color */\n\n.form-element-button-theme-blue-secondary {\n  box-shadow: inset 0px 0px 0px 2px var(--primary-color-a);\n  color: var(--primary-color-a);\n}\n\n.form-element-button-theme-blue-secondary:hover {\n  box-shadow: inset 0px 0px 0px 3px var(--primary-color-a-6);\n  color: var(--primary-color-a);\n}\n\n.form-element-button-theme-blue-secondary:active {\n  box-shadow: inset 0px 0px 0px 2px var(--primary-color-a-7);\n  color: var(--primary-color-a-7);\n}\n\n/* black secondary color */\n\n.form-element-button-theme-black-secondary {\n  box-shadow: inset 0px 0px 0px 2px var(--primary-color-b);\n  color: var(--primary-color-b);\n}\n\n.form-element-button-theme-black-secondary:hover {\n  box-shadow: inset 0px 0px 0px 3px var(--primary-color-b);\n  color: var(--primary-color-b);\n}\n\n.form-element-button-theme-black-secondary:active {\n  box-shadow: inset 0px 0px 0px 2px var(--primary-color-b);\n  color: var(--primary-color-b);\n}\n\n/* disabled */\n\n.form-element-button:disabled {\n  cursor: default;\n}\n\n.form-element-button.primary:disabled {\n  background-color: var(--neutral-color-a-1);\n  color: var(--neutral-color-a-2);\n}\n\n.form-element-button.secondary:disabled {\n  background-color: var(--primary-bg-color);\n  color: var(--neutral-color-a-1);\n  box-shadow: inset 0px 0px 0px 2px var(--neutral-color-a-1);\n}\n\n@media (max-width: 550px) {\n  .form-element-button {\n    height: 48px;\n  }\n\n  .form-element-button div {\n    line-height: 48px;\n  }\n}\n\n\n.form-element-button:disabled,\n.form-element-button:disabled:hover {\n  cursor: not-allowed;\n  pointer-events: none;\n  background-color: var(--neutral-color-a-1);\n}\n\n.pricing-card:hover .form-element-button:disabled {\n  background-color: var(--neutral-color-a-1) !important;\n}\n\n.pricing-card:has(.form-element-button:disabled):hover {\n  background-color: inherit !important;\n}\n\n.pricing-card:has(.form-element-button:disabled) .pricing-card-name,\n.pricing-card:has(.form-element-button:disabled) .pricing-card-price-amount,\n.pricing-card:has(.form-element-button:disabled) .pricing-card-price-per {\n  color: inherit !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
